import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import "./return-exchange.css";

export default function ReturnExchange() {
    const [openFaq, setOpenFaq] = useState(0);
  const faqItems = [
  {
    question: "Can I cancel my order?",
    answer: "Yes, only before dispatch.",
  },
  {
    question: "What if my order arrives damaged or incorrect?",
    answer:
      "Please email us within 48 hours with photos/videos and an unboxing video.",
  },
  {
    question: "Can I return a candle if I don’t like the fragrance?",
    answer:
      "No, fragrance preference is subjective, so returns are not accepted for scent-related concerns.",
  },
  {
    question: "Why does my candle look slightly different?",
    answer:
      "As our products are handcrafted, slight variations in colour, texture, or finish are natural.",
  },
];
  return (
    <>
      <Header />

      <main className="return-page">
        <div className="return-hero">
          <h1>Returns & Exchange Policy</h1>
          <p>
            Every Aethearia product is handcrafted with care in small batches.
          </p>
        </div>

        <div className="return-grid">
          <section className="policy-card">
            <span className="section-tag">Returns Policy</span>

            <h2>Returns & Exchange Policy</h2>

            <p>
              At Aethearia, every product is handcrafted with care in small
              batches. Due to the handmade and delicate nature of our products,
              we do not accept returns or exchanges for items delivered in
              perfect condition.
            </p>

            <h3>Order Cancellation</h3>

            <ul>
              <li>
                Orders can be cancelled only before dispatch. Once shipped,
                cancellations are not possible.
              </li>
              <li>
                For cancellation requests, please contact us at{" "}
                <span className="email-lowercase">hello@aethearia.com</span>.
              </li>
            </ul>

            <h3>Damaged, Defective or Incorrect Products</h3>

            <p>
              If your order arrives damaged, defective, or incorrect, please
              contact us within 48 hours of delivery at{" "}
              <span className="email-lowercase">reachus@aethearia.com</span>{" "}
              with:
            </p>

            <ul>
              <li>Your order number</li>
              <li>Clear photos/videos of the issue</li>
              <li>An unboxing video recorded while opening the parcel</li>
            </ul>

            <p className="note-highlight">
              Please note that claims for damaged, missing, or incorrect items
              may only be considered if supported by an unboxing video.
            </p>

            <p>
              Once verified, we will offer a replacement, exchange, store
              credit, or suitable resolution, depending on the case.
            </p>
          </section>

          <section className="policy-card">
            <span className="section-tag">Returns & Refunds</span>

            <h2>Returns & Exchanges</h2>

            <p>We do not accept returns or exchanges for:</p>

            <ul>
              <li>Change of mind or fragrance preference</li>
              <li>Used, lit, opened, or damaged products after delivery</li>
              <li>Sale, discounted, customized, or limited-edition items</li>
              <li>
                Minor variations in colour, texture, or finish are natural in
                handcrafted products and are not considered defects.
              </li>
            </ul>

            <h3>Refunds</h3>

            <p>
              Approved refunds, if applicable, will be processed to the original
              payment method within 5–10 business days.
            </p>

            <p>
              For any assistance, write to us at{" "}
              <span className="email-lowercase">reachus@aethearia.com</span>.
            </p>
          </section>
        </div>
        <section className="return-faq-section">
  <h2>FAQ</h2>

  <div className="return-faq-accordion">
    {faqItems.map((item, index) => (
      <div className="return-faq-item" key={index}>
        <button
          className="return-faq-question"
          onClick={() => setOpenFaq(openFaq === index ? null : index)}
          aria-expanded={openFaq === index}
        >
          <span style={{ color: '#4c144e' }}>{item.question}</span>
          <span className="faq-icon">{openFaq === index ? "−" : "+"}</span>
        </button>

        {openFaq === index && (
          <div className="return-faq-answer">
            <p>{item.answer}</p>
          </div>
        )}
      </div>
    ))}
  </div>
</section>
      </main>

      <Footer />
    </>
  );
}